module.exports = __webpack_public_path__ + "static/haus_4k-83873e4f8d6f146260183aa593094b2b.webp";